export function normalize_permission_name(permission) {
  return String(permission || "").trim().toLowerCase();
}

export function normalize_feature_keys(featureKeys = []) {
  return (Array.isArray(featureKeys) ? featureKeys : [featureKeys])
    .filter(Boolean)
    .map((key) => normalize_permission_name(key));
}

export function get_organization_permission_assignments(shared_permissions = [], current_permissions = [], fallback_permissions = []) {
  return [shared_permissions, current_permissions, fallback_permissions]
    .find((permissions) => Array.isArray(permissions) && permissions.length) || [];
}

export function has_organization_permission({
  featureKeys = [],
  permissionName = "create",
  permissions = [],
  userRole = "",
  adminRoles = ["admin"],
} = {}) {
  const normalized_user_role = normalize_permission_name(userRole);
  const normalized_admin_roles = adminRoles.map(normalize_permission_name);

  if (normalized_admin_roles.includes(normalized_user_role)) {
    return true;
  }

  const allowedFeatureKeys = new Set(normalize_feature_keys(featureKeys));
  const requiredPermission = normalize_permission_name(permissionName);

  return (Array.isArray(permissions) ? permissions : []).some((assignment) => {
    const featureKey = normalize_permission_name(assignment?.feature?.key);
    const assignedPermission = normalize_permission_name(assignment?.permission?.name);
    return allowedFeatureKeys.has(featureKey) && assignedPermission === requiredPermission;
  });
}
